/**
 * Data URI encodings
 * @module data-uri/encodings
 */

/**
 * Base 64 encoded data
 */
export const ENCODING_BASE64 = 'base64'
